import { render, staticRenderFns } from "./StatsSellers.vue?vue&type=template&id=5da2041a&"
import script from "./StatsSellers.vue?vue&type=script&lang=js&"
export * from "./StatsSellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports